import React from 'react';
import Dashboard from './index';
import UserDashboard from './UserDashboard';

const DashboardSwitcher = () => {
  let user = null;
  try {
    user = JSON.parse(localStorage.getItem('user')) ||
           JSON.parse(localStorage.getItem('authUser') || 'null')?.user;
  } catch { /* ignore */ }
  const role = (user?.role || user?.user_role || user?.type || localStorage.getItem('role') || '').toLowerCase();

  if (role === 'user') {
    return <UserDashboard />;
  }
  return <Dashboard />;
};

export default DashboardSwitcher;
